import { render, staticRenderFns } from "./fitnessDetail.vue?vue&type=template&id=3e014ab2&scoped=true&"
import script from "./fitnessDetail.vue?vue&type=script&lang=js&"
export * from "./fitnessDetail.vue?vue&type=script&lang=js&"
import style0 from "./fitnessDetail.vue?vue&type=style&index=0&id=3e014ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e014ab2",
  null
  
)

export default component.exports